"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointStats = void 0;
class EndpointStats {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointStats.attributeTypeMap;
    }
}
exports.EndpointStats = EndpointStats;
EndpointStats.discriminator = undefined;
EndpointStats.attributeTypeMap = [
    {
        "name": "fail",
        "baseName": "fail",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "pending",
        "baseName": "pending",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "sending",
        "baseName": "sending",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "success",
        "baseName": "success",
        "type": "number",
        "format": "int64"
    }
];
//# sourceMappingURL=EndpointStats.js.map